import React, { useState, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { List } from "@cars24/turbo-web/lib/list";
import { Label } from "@cars24/turbo-web/lib/label";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { NUMBER } from "../../../constants/app-constants";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { getDlsCompatibleCityList } from "./selector";
import ArrowIcon from "../../shared/arrow";
import GenericBrandBanner from "../generic-brand-banner";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";

const LIST_THRESHOLD_LIMIT_MSITE = 5;

const RtoVehInfoPopularCities = ({
    popularCityDetails,
    isDesktop = false,
    websiteAds = {},
    websiteAdvertisementBannerData = false

}) => {
    const buyListRef = useRef();
    const sellListRef = useRef();
    const { tokens } = useTokens();
    const [isBuyListOpen, setIsBuyListOpen] = useState(false);
    const [isSellListOpen, setIsSellListOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const details = useMemo(() => getDlsCompatibleCityList(popularCityDetails), [popularCityDetails]);
    const { buyCarCityList = [], sellCarCityList = [] } = details || {};

    // eslint-disable-next-line max-params
    const onViewMoreHandler = async (listRef, isListOpen, setIsListOpen) => {
        setLoading(true);
        setIsListOpen(!isListOpen);

        await yieldToMain();

        if (isListOpen && listRef && listRef.current) {
            listRef.current.scrollIntoView();
        }

        setLoading(false);
    };

    const getTitle = (isBuyCarList) => `${isBuyCarList ? "Buy" : "Sell"} used car in popular cities`;

    // eslint-disable-next-line max-params
    const renderList = (itemList, isBuyCarList, isListOpen, listRef, setIsListOpen) => {
        return (
            <React.Fragment>
                {
                    isDesktop ? <Heading level={NUMBER.FOUR}>{getTitle(isBuyCarList)}</Heading> :
                        <Label level={NUMBER.ONE} fontWeight={"semibold"}>{getTitle(isBuyCarList)}</Label>
                }
                <List items={itemList} />
                {
                    itemList && itemList.length > LIST_THRESHOLD_LIMIT_MSITE &&
                    <div styleName={`styles.readMore ${loading ? "styles.loadingBtn" : ""}`} onClick={() => onViewMoreHandler(listRef, isListOpen, setIsListOpen)}>
                        <Label
                            level={NUMBER.THREE}
                            fontWeight={"semibold"}
                            color={tokens.text_brand_text_brand}
                        >
                            {!isListOpen ? "View more cities" : "View less cities"}
                            <ArrowIcon />
                        </Label>
                    </div>

                }
            </React.Fragment>
        );
    };

    return (
        <div className={"cvh"}>
            {
                buyCarCityList && !!buyCarCityList.length &&
                <div ref={buyListRef} styleName={`${isBuyListOpen ? "styles.popularCitiesViewMore" : "styles.popularCitiesViewLess"}`}>
                    {renderList(buyCarCityList, true, isBuyListOpen, buyListRef, setIsBuyListOpen)}
                </div>
            }
            { websiteAdvertisementBannerData && <div styleName={"styles.adsBanner"}><GenericBrandBanner config={websiteAds} type={ isDesktop ? "970x90" : "320x100"} fetchpriority="high" pageType="rto-info"  position = "bottom" source = {isDesktop ? "webApp" : "mSite"}/></div>}
            {
                sellCarCityList && !!sellCarCityList.length &&
                <div ref={sellListRef} styleName={`${isSellListOpen ? "styles.popularCitiesViewMore" : "styles.popularCitiesViewLess"}`}>
                    {renderList(sellCarCityList, false, isSellListOpen, sellListRef, setIsSellListOpen)}
                </div>
            }
        </div>
    );
};

RtoVehInfoPopularCities.propTypes = {
    popularCityDetails: PropTypes.object,
    isDesktop: PropTypes.bool,
    websiteAds: PropTypes.object,
    websiteAdvertisementBannerData: PropTypes.bool
};

export default RtoVehInfoPopularCities;
